// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import iView from 'iview';
import i18n from '@/locale';
import config from '@/config';
//import importDirective from '@/directive';
import { directive as clickOutside } from 'v-click-outside-x';
import print from 'print-js';
import installPlugin from '@/plugin';
import './index.less';
import '@/assets/icons/iconfont.css';
import TreeTable from 'tree-table-vue';
import VOrgTree from 'v-org-tree';
import 'v-org-tree/dist/v-org-tree.css';
import loginState from '@/libs/loginState';
import VueClipboard from 'vue-clipboard2';
import BackgroundPlugin from './plugin/backgroundPlugin/backgroundPlugin';
import'./global.css';
import * as echarts from 'echarts';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
VueClipboard.config.autoSetContainer = true;

console.log("process.env.NODE_ENV==>: ", process.env.NODE_ENV);

Vue.use(VueClipboard);

// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')

Vue.use(VXETable)

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(TreeTable)
Vue.use(VOrgTree)
Vue.use(BackgroundPlugin);
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.imageDomain = 'http://img.brighten-floriplant.cn/';

Vue.prototype.$config = config

Vue.prototype.$echarts = echarts;

Vue.prototype.$globalSpin = false;
Vue.prototype.$showGlobalSpin = function () {
  this.$globalSpin = true;
};
Vue.prototype.$hideGlobalSpin = function () {
  this.$globalSpin = false;
};

Vue.prototype.$downLoadFile = function (url) {
  let fileName = url.split('/').pop();

  // 1. 自动触发原有的直接下载逻辑
  let autoLink = document.createElement("a");
  autoLink.style.display = "none";
  autoLink.href = url;
  autoLink.setAttribute("download", fileName); // 指定下载后的文件名，防跳转
  autoLink.setAttribute("target", "_blank");   // 使用新窗口打开，防止当前页面刷新或跳转丢失状态
  document.body.appendChild(autoLink);
  autoLink.click();

  // 保持 DOM 整洁，完成点击后较短时间内移除 a 标签
  setTimeout(() => {
    if (document.body.contains(autoLink)) {
      document.body.removeChild(autoLink);
    }
  }, 500);

  // 2. 同时在右下角弹出手动下载提示框，以防浏览器拦截或找不着文件
  // 移除旧的弹窗（如果存在，防止叠加）
  let oldContainer = document.getElementById("manual-download-notice");
  if (oldContainer && document.body.contains(oldContainer)) {
    document.body.removeChild(oldContainer);
  }

  // 创建右下角弹窗容器
  let container = document.createElement("div");
  container.id = "manual-download-notice";
  container.style.position = "fixed";
  container.style.bottom = "20px";
  container.style.right = "-350px"; // 初始在屏幕外，用于动画滑入
  container.style.width = "300px";
  container.style.padding = "16px";
  container.style.backgroundColor = "#fff";
  container.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
  container.style.borderRadius = "4px";
  container.style.zIndex = "9999";
  container.style.transition = "right 0.3s ease-in-out";
  container.style.display = "flex";
  container.style.flexDirection = "column";

  // 标题和关闭按钮栏
  let header = document.createElement("div");
  header.style.display = "flex";
  header.style.justifyContent = "space-between";
  header.style.alignItems = "center";
  header.style.marginBottom = "10px";

  let title = document.createElement("span");
  title.innerText = "导出成功";
  title.style.fontWeight = "bold";
  title.style.color = "#17233d";
  title.style.fontSize = "16px";

  let closeBtn = document.createElement("span");
  closeBtn.innerText = "✕";
  closeBtn.style.cursor = "pointer";
  closeBtn.style.color = "#999";
  closeBtn.style.fontSize = "16px";
  closeBtn.onclick = function() {
    container.style.right = "-350px";
    setTimeout(() => { if(document.body.contains(container)) document.body.removeChild(container); }, 300);
  };

  header.appendChild(title);
  header.appendChild(closeBtn);

  // 内容区：包含描述和下载链接
  let content = document.createElement("div");
  content.style.fontSize = "14px";
  content.style.color = "#515a6e";
  content.innerText = "您的文件已准备就绪，";

  let link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  link.innerText = "点击手动下载";
  link.style.color = "#2d8cf0";
  link.style.textDecoration = "underline";
  link.style.fontWeight = "bold";
  link.style.cursor = "pointer";
  // 点击后自动关闭弹窗
  link.onclick = function() {
    setTimeout(() => {
      container.style.right = "-350px";
      setTimeout(() => {
        if(document.body.contains(container)) document.body.removeChild(container);
      }, 300);
    }, 500);
  };

  content.appendChild(link);

  container.appendChild(header);
  container.appendChild(content);
  document.body.appendChild(container);

  // 触发动画滑入
  setTimeout(() => {
    container.style.right = "20px";
  }, 10);

  // 15秒后自动移除（可选，防止一直挡住其它信息）
  setTimeout(() => {
    if (document.body.contains(container)) {
      container.style.right = "-350px";
      setTimeout(() => {
        if(document.body.contains(container)) document.body.removeChild(container);
      }, 300);
    }
  }, 15000);
};
/**
 * 注册指令
 */
//importDirective(Vue)
Vue.directive('clickOutside', clickOutside)

Vue.prototype.$checkAccessArray = function (access) {
  let accessArray = loginState.getLoginAccess();
 let accessArr = accessArray.toString().split(',');
 return !!accessArr.find(v => access.includes(v));
};
Vue.prototype.getCurrentMonthDateRange = function () {
  const date = new Date();

  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  firstDay.setHours(0, 0, 0, 0);

  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  lastDay.setHours(23, 59, 59, 999);

  const formatDate = date => {
    const pad = num => num.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  return [formatDate(firstDay), formatDate(lastDay)];
};
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})
